import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  LOAD_AVAILABLE_PAYMENT_METHODS: null,
  LOAD_AVAILABLE_PAYMENT_METHODS_SUCCESS: null,
  LOAD_AVAILABLE_PAYMENT_METHODS_FAILED: null,

  [`PAYCHECKOUT_LOAD_SETTINGS`]: null,
  [`PAYCHECKOUT_LOAD_SETTINGS_SUCCESS`]: null,
  [`PAYCHECKOUT_LOAD_SETTINGS_FAILED`]: null,

  [`PAYCHECKOUT_UPDATE_SETTINGS`]: null,
  [`PAYCHECKOUT_UPDATE_SETTINGS_SUCCESS`]: null,
  [`PAYCHECKOUT_UPDATE_SETTINGS_FAILED`]: null,

  PAYCHECKOUT_LOAD_CONFIGURATION: null,
  PAYCHECKOUT_LOAD_CONFIGURATION_SUCCESS: null,
  PAYCHECKOUT_LOAD_CONFIGURATION_FAILED: null,

  PAYCHECKOUT_UPDATE_CONFIGURATION: null,
  PAYCHECKOUT_UPDATE_CONFIGURATION_SUCCESS: null,
  PAYCHECKOUT_UPDATE_CONFIGURATION_FAILED: null,

  SET_SHOW_CREATE_PAYMENT_CHECKOUT_MODAL: null,
  SET_SHOW_CREATE_REUSABLE_MODAL: null,
});
